import React from 'react'
import {
  PixelFactoryContext,
  PixelFlexBox,
  DcInput,
  PixelText,
  DcButton,
  colors,
  DcText,
  DcDiv,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs/ajax'

import { validateShopifyStoreOnboarding } from 'utils/api-routes.util'
import {
  WebsiteDataContainer,
  WebsiteDataTitle,
  WebsiteDataURL,
} from 'app/common/styles/section'
import { IPixelFactory } from '../../../../../decl'

const AddShopifyStore = (props) => {
  const { origin } = props
  const { showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [data, setData] = React.useState({
    store_name: '',
    domain: '',
  })
  const [error, setError] = React.useState({ field: '', error: '' })
  const [validatedData, setValidatedData] = React.useState({
    auth_url: '',
    favicon: '',
    id: 0,
    title: '',
    url: '',
    validated: false,
  })

  const handleConnectClick = () => {
    window.open(validatedData.auth_url, '_blank')
  }
  const handleSubmit = () => {
    if (!data.store_name) {
      setError({
        error: 'Please enter a store name',
        field: 'store_name',
      })
      return
    } else if (!data.domain) {
      setError({
        error: 'Please enter a domain',
        field: 'domain',
      })
      return
    }

    handleValidateShopifyStore(data, setValidatedData)
  }

  const handleValidateShopifyStore = (data, setValidatedData) => {
    showPageLoader()
    validateShopifyStoreOnboarding({
      store_name: data.store_name,
      shop: data.domain,
      origin: origin,
    }).subscribe((res: AjaxResponse<any>) => {
      hidePageLoader()
      if (res.response.data) {
        // success case
        localStorage.setItem(
          'lastShopifyStore',
          JSON.stringify(res.response.data),
        )
        setValidatedData(res.response.data)
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
      }
    })
  }
  const fieldStyle = {
    display: 'flex',
    flexDirection: 'column' as const,
    marginTop: '20px',
    textAlign: 'left' as const,
  }
  const labelStyle = {
    margin: '0 0 8px 0',
    fontSize: '14px',
    fontWeight: 500,
    color: '#344054',
  }

  return (
    <PixelFlexBox width="100%" height="auto" flexDirection="column" gap="0">
      <DcText
        customColor={colors.grayTextDark}
        style={{
          fontSize: '14px',
          lineHeight: 1.5,
          marginBottom: '20px',
          color: '#64748b',
        }}
      >
        Connect your Shopify store to sync orders and products with PixelOne.
      </DcText>

      <DcDiv width="100%" height="auto" style={fieldStyle}>
        <DcText customColor={colors.grayTextDark} style={labelStyle}>
          Store name
        </DcText>
        <DcInput
          placeholder="e.g. My Shopify Store"
          error={
            error.field === data.store_name && error.error !== ''
              ? error.error
              : null
          }
          value={data.store_name}
          readOnly={validatedData.validated}
          required
          onChange={(e) => setData({ ...data, store_name: e.target.value })}
        />
      </DcDiv>

      <DcDiv width="100%" height="auto" style={fieldStyle}>
        <DcText customColor={colors.grayTextDark} style={labelStyle}>
          Store domain
        </DcText>
        <DcInput
          error={
            error.field === 'domain' && error.error !== '' ? error.error : null
          }
          value={data.domain}
          required
          onChange={(e) => setData({ ...data, domain: e.target.value })}
          placeholder="mystore.myshopify.com"
        />
      </DcDiv>

      {validatedData.validated ? (
        <WebsiteDataContainer style={{ marginTop: '24px' }}>
          <PixelText variant="light">
            {`We're going to send you to your store now to give PixelOne
            permission to access your data (orders, customers, etc.).
            Then the magic happens.`}
          </PixelText>
          <PixelFlexBox
            flexDirection="column"
            justifyContent="space-between"
            alignItems="flex-start"
            alignContent="flex-start"
            style={{ padding: '0px' }}
            height="auto"
            gap="16px"
          >
            <PixelFlexBox flexDirection="column" height="auto">
              <WebsiteDataTitle>{validatedData.title}</WebsiteDataTitle>
              <WebsiteDataURL>{validatedData.url}</WebsiteDataURL>
            </PixelFlexBox>
            <PixelFlexBox gap="12px" height="auto" justifyContent="flex-end">
              <DcButton
                width="50%"
                variant="secondary"
                onClick={() => {
                  setValidatedData({
                    ...validatedData,
                    validated: false,
                  })
                }}
              >
                Change
              </DcButton>
              <DcButton
                width="50%"
                onClick={handleConnectClick}
                variant="gradient"
              >
                Connect
              </DcButton>
            </PixelFlexBox>
          </PixelFlexBox>
        </WebsiteDataContainer>
      ) : (
        <PixelFlexBox
          flexDirection="column"
          justifyContent="flex-end"
          alignItems="stretch"
          gap="12px"
          style={{ marginTop: '28px' }}
        >
          <DcButton width="25%" variant="gradient" onClick={handleSubmit}>
            Connect store
          </DcButton>
        </PixelFlexBox>
      )}
    </PixelFlexBox>
  )
}

export default AddShopifyStore
